import type { StudentReportItem } from '@/school-management/types/response';
import type { ClassOverviewData } from '@/types/progress';

export type GroupDetailsFromStudentRows = {
  additionalTeacherName?: {
    id: string;
    firstName: string;
    lastName: string;
  };
} | null;

export function inferGroupDetailsFromStudentRows(
  items: StudentReportItem[],
  currentUserId?: string | null
): GroupDetailsFromStudentRows {
  const seen = new Map<string, { firstName: string; lastName: string }>();
  for (const row of items) {
    for (const te of row.teachers || []) {
      if (te.userId && !seen.has(te.userId)) {
        seen.set(te.userId, { firstName: te.firstName, lastName: te.lastName });
      }
    }
  }
  if (seen.size <= 1) return null;
  for (const [id, name] of seen) {
    if (id !== currentUserId) {
      return { additionalTeacherName: { id, ...name } };
    }
  }
  return null;
}

export function studentReportItemToClassOverviewData(row: StudentReportItem): ClassOverviewData {
  const trimmed = (row.name || '').trim();
  const parts = trimmed ? trimmed.split(/\s+/) : [];
  const firstName = parts[0] || '';
  const lastName = parts.slice(1).join(' ') || '';

  return {
    id: row.userId,
    firstName,
    lastName,
    level: row.currentLevel,
    username: row.username ?? undefined,
    email: row.email ?? undefined,
    userStatus: row.userStatus,
    levelTestResult: row.startingLevel,
    userSessionInfo: {
      firstLogin: row.firstLogin ?? undefined,
      lastLogin: row.lastLogin ?? undefined,
    },
    progress: {
      completedActivities: row.completedActivities,
      totalActivities: 0,
      aVGScore: row.averageScore ?? row.score ?? 0,
      activitiesProgress: row.progress,
      timeSpent: row.timeSpentSeconds,
    },
  };
}
